import APITemplate from '@api/APITemplate'
import con from '@services/connection'
import { intelligenceV2 } from '@modules/aawz-intelligence-v2/constants/URL'

/**
 * `GET /agentes` — os especialistas que a tela pode oferecer para rodar o
 * turno do Modo Agente (ponte decidida pelo owner em 16/09/2026; backend no
 * PR #1787, `core/agentes/selecionaveis.py`).
 *
 * Por que a lista vem do servidor e nunca daqui: o catálogo tem 17 agentes
 * `roteavel: true`, e o que CADA profissional pode escolher depende de dois
 * eixos de RBAC que só o backend conhece — papel (`gestor_only`: Controller,
 * Management Intelligence, Partnership & Compensation) e funcionalidade
 * contratada (`IA - Fee Fixo`, `IA CRM Chat`, `Solicitações`). Uma lista
 * hardcoded ofereceria agente que o aceite recusa.
 *
 * `value` é `[{slug, nome, descricao, pergunta_guia}]` — os `CAMPOS_PUBLICOS`
 * do produtor. `system_prompt`/`runtime_config` são internos e não vêm.
 */
class APIAgentes extends APITemplate {
  /**
   * @returns {Promise<Object>} `Envelope` — `value` é a lista já ∩ RBAC.
   *
   * O envelope volta CRU de propósito: quem transforma em lista de seleção é
   * `utils/agentes-selecionaveis.js`, que também é quem sabe degradar (a rota
   * não existe em `desenvolvimento` até o #1787 entrar, e o composer não pode
   * quebrar por causa disso).
   */
  async listarSelecionaveis() {
    const r = await con.get(intelligenceV2.agentes)
    return r || this.buildErrorResponse({ message: 'Erro inesperado' })
  }
}

export const apiAgentes = new APIAgentes()
